import { getCheck24Namespace } from '../Provide/Namespace/getCheck24Namespace';

enum StatsDType {
    Increment = 'increment',
    Decrement = 'decrement',
    Timing = 'timing',
}

export enum CacheHit {
    Hit = 'cache_hit',
    Partial = 'cache_partial',
    Miss = 'cache_miss',
}

export function trackStatsDRegionListTiming(duration: number) {
    dispatchStatsDEvent(
        'regionlist.search_duration',
        StatsDType.Timing,
        duration
    );
}

export function trackStatsDHotelListTiming(duration: number) {
    dispatchStatsDEvent(
        'hotellist.streaming.search_duration',
        StatsDType.Timing,
        duration
    );
}

export function trackStatsDHotelListCacheHit(cacheHit: CacheHit) {
    dispatchStatsDEvent(`hotellist.streaming.${cacheHit}`);
}

export function trackStatsDOfferListTiming(duration: number) {
    dispatchStatsDEvent(
        'offerlist.streaming.search_duration',
        StatsDType.Timing,
        duration
    );
}

export function trackStatsDOfferListCacheHit(cacheHit: CacheHit) {
    dispatchStatsDEvent(`offerlist.streaming.${cacheHit}`);
}

export function dispatchStatsDEvent(key: string): void;
export function dispatchStatsDEvent(
    key: string,
    type: StatsDType.Increment | StatsDType.Decrement
): void;
export function dispatchStatsDEvent(
    key: string,
    type: StatsDType.Timing,
    amount: number
): void;

export function dispatchStatsDEvent(
    key: string,
    type = StatsDType.Increment,
    amount?: number
): void {
    const namespace = getCheck24Namespace();
    window.dispatchEvent(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        new CustomEvent(namespace._registry.events.statsdPush, {
            detail: {
                key,
                type,
                amount,
            },
        })
    );
}
